var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../Button';
import styled from '../../utils/styled-components';
var StyledFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  padding: ", ";\n  background: ", ";\n  border-top: ", ";\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  padding: ", ";\n  background: ", ";\n  border-top: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.modal.footer.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.footer.background;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.footer.border;
});
var StyledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: ", ";\n  margin: ", ";\n  white-space: nowrap;\n\n  @media (min-width: ", ") {\n    flex: initial;\n  }\n"], ["\n  flex: ", ";\n  margin: ", ";\n  white-space: nowrap;\n\n  @media (min-width: ", ") {\n    flex: initial;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return "1 0 calc(50% - " + component.modal.button.padding + " * 2)";
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.button.margin;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.tablet;
});
/**
 * Footer for the modal component
 * with the possibility to render 4 different use cases:
 * 1. Nothing if there is no onCancel and no onSubmit function
 * 2. Cancel button with onCancel function
 * 3. Submit button with onSubmit function
 * 4. Combination of 2. and 3.
 */
var Footer = function (_a) {
    var cancelButtonText = _a.cancelButtonText, onCancel = _a.onCancel, onSubmit = _a.onSubmit, submitButtonText = _a.submitButtonText, trackIdSubmit = _a.trackIdSubmit, trackIdCancel = _a.trackIdCancel, testIdCancel = _a.testIdCancel, testIdSubmit = _a.testIdSubmit;
    if (!onCancel && !onSubmit) {
        return null;
    }
    return (React.createElement(StyledFooter, null,
        onCancel && (React.createElement(StyledButton, { "data-testid": testIdCancel, "data-trackid": trackIdCancel, onClick: onCancel }, cancelButtonText || React.createElement(FormattedMessage, { defaultMessage: "Cancel", id: "modal.close" }))),
        onSubmit && (React.createElement(StyledButton, { "data-testid": testIdSubmit, "data-trackid": trackIdSubmit, onClick: onSubmit, layout: "primary" }, submitButtonText || React.createElement(FormattedMessage, { defaultMessage: "Submit", id: "modal.submit" })))));
};
export default Footer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map